import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'login',
			component: resolve => require(['../components/login'], resolve)
		},
		{
			path: '/',
			name: '/',
			component: Index,
			children: [
				{
					path: '/userManage',
					name: 'userManage',
					component: resolve => require(['../components/userManage'], resolve)
				},
				{
					path: '/branchManage',
					name: 'branchManage',
					component: resolve => require(['../components/branchManage'], resolve)
				},
				{
					path: '/noticeManage',
					name: 'noticeManage',
					component: resolve => require(['../components/noticeManage.vue'], resolve)
				},
				{
					path: '/bannerManage',
					name: 'bannerManage',
					component: resolve => require(['../components/bannerManage.vue'], resolve)
				},
				{
					path: '/courseManage',
					name: 'courseManage',
					component: resolve => require(['../components/courseManage.vue'], resolve)
				},
				{
					path: '/stopManage',
					name: 'stopManage',
					component: resolve => require(['../components/stopManage.vue'], resolve)
				},
				{
					path: '/classManage',
					name: 'classManage',
					component: resolve => require(['../components/classManage.vue'], resolve)
				},
				{
					path: '/stuCount',
					name: 'stuCount',
					component: resolve => require(['../components/stuCount.vue'], resolve)
				},
				{
					path: '/teacherCount',
					name: 'teacherCount',
					component: resolve => require(['../components/teacherCount.vue'], resolve)
				},
				{
					path: '/cardCount',
					name: 'cardCount',
					component: resolve => require(['../components/cardCount.vue'], resolve)
				},

			],

		},
		{
			path: '*',
			name: 'notFound',
			component: resolve => require(['../components/notFound'], resolve)
		}
	],
	// mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js